<template>
	<o-section :title="setup.pageTitle">
		<div class="form flex fd-c g-sm">
			<o-input
				v-model="setup.entity.company"
				autofocus
				label="Société"
				:validation="setup.validator?.rule('company')"/>

			<o-input
				v-model="setup.entity.position"
				label="Poste occupé"
				:validation="setup.validator?.rule('position')"/>

			<o-select
				v-model="setup.entity.professionalSkills"
				display-key="label"
				track-key="code"
				multiple
				label="Qualification"
				searchable
				:options="setup.skillOptions"/>

			<o-datepicker
				v-model="setup.entity.startDate"
				:max-date="new Date()"
				type="date"
				clearable
				label="Date de début"
				:validation="setup.validator?.rule('startDate')"/>

			<o-datepicker
				v-if="!setup.entity.isCurrentPosition"
				v-model="setup.entity.endDate"
				:min-date="setup.entity.startDate"
				type="date"
				clearable
				label="Date de fin"
				:required="!setup.entity.isCurrentPosition"
				:validation="setup.validator?.rule('endDate')"/>

			<o-toggle
				v-model="setup.entity.isCurrentPosition"
				label="Occupé aujourd'hui"/>

			<div class="flex g-xs mt-sm">
				<o-button
					block
					color="danger"
					outline
					@click="_modal?.close()">
					Annuler
				</o-button>
				<o-button
					block
					:color="setup.entity.isNew ? 'success' : 'info'"
					@click="setup.addOrUpdateAsync()">
					{{ setup.entity.isNew ? 'Ajouter' : 'Enregistrer' }}
				</o-button>
			</div>
		</div>
	</o-section>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import UserProfileProExpAsideNewSetupService from '@/setup/user-profile/UserProfileProExpAsideNewSetupService';
const _modal = inject<OrionModal>('_modal');
const props = defineProps(UserProfileProExpAsideNewSetupService.props);
const setup = new UserProfileProExpAsideNewSetupService(props, _modal);
</script>
